import type { InstallationTab } from '../types'

export const SCROLL_MARGIN_DESKTOP = '8rem'

export const FALLBACK_INSTALLATION_TAB: InstallationTab = {
  label: 'Installation',
  code: 'Select a technology.',
  language: 'text',
}
